import React, { useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { Loader2, X, CheckCircle2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export function ForgotPasswordModal({ open, onClose, role }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!open) return null;
  async function submit(e) {
    e.preventDefault(); setBusy(true);
    try {
      const origin = window.location.origin;
      await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${origin}/auth/reset-password` });
    } catch { /* swallow — always show generic */ }
    setBusy(false); setDone(true);
  }
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="forgot-pw-modal">
      <div className="sb-card p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between"><h3 className="text-[18px] font-black">Forgot password</h3><button onClick={onClose} className="text-[#A1A1AA]"><X size={16} /></button></div>
        {done ? (
          <div className="mt-4" data-testid="forgot-pw-done">
            <div className="flex items-center gap-2 text-[#22C55E]"><CheckCircle2 size={14} /><b>Check your email</b></div>
            <p className="mt-2 text-[13px] text-[#A1A1AA]">If an account exists for that email, we&apos;ve sent password reset instructions.</p>
            <button onClick={onClose} className="mt-4 sb-btn-secondary text-[11px]" style={{ padding: "8px 14px" }}>Close</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3" data-testid="forgot-pw-form">
            <p className="text-[13px] text-[#A1A1AA]">Enter the email you use for your {role || "SpotBounty"} account.</p>
            <label className="block"><div className="sb-label">Email</div>
              <input type="email" required className="sb-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-pw-email" /></label>
            <button type="submit" disabled={busy} className="sb-btn-primary w-full" data-testid="forgot-pw-submit">
              {busy ? <Loader2 size={14} className="animate-spin" /> : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export function ForgotEmailModal({ open, onClose, defaultRole }) {
  const [f, setF] = useState({ name: "", phone: "", role: defaultRole || "scout", email: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!open) return null;
  async function submit(e) {
    e.preventDefault(); setBusy(true);
    try {
      await fetch(`${API}/api/support/account-recovery`, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(f),
      });
    } catch { /* swallow — always show generic */ }
    setBusy(false); setDone(true);
  }
  const upd = (k, v) => setF({ ...f, [k]: v });
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="forgot-email-modal">
      <div className="sb-card p-6 max-w-md w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between"><h3 className="text-[18px] font-black">Forgot the email you signed up with?</h3><button onClick={onClose} className="text-[#A1A1AA]"><X size={16} /></button></div>
        {done ? (
          <div className="mt-4" data-testid="forgot-email-done">
            <div className="flex items-center gap-2 text-[#22C55E]"><CheckCircle2 size={14} /><b>Thanks</b></div>
            <p className="mt-2 text-[13px] text-[#A1A1AA]">SpotBounty will contact you at the email you provided if we can help locate your account.</p>
            <button onClick={onClose} className="mt-4 sb-btn-secondary text-[11px]" style={{ padding: "8px 14px" }}>Close</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3" data-testid="forgot-email-form">
            <div className="grid grid-cols-2 gap-2">
              <label className="block"><div className="sb-label">Full name *</div><input required className="sb-input" value={f.name} onChange={(e) => upd("name", e.target.value)} data-testid="forgot-email-name" /></label>
              <label className="block"><div className="sb-label">Phone *</div><input required className="sb-input" value={f.phone} onChange={(e) => upd("phone", e.target.value)} data-testid="forgot-email-phone" /></label>
            </div>
            <label className="block"><div className="sb-label">Account type *</div>
              <select className="sb-input" value={f.role} onChange={(e) => upd("role", e.target.value)} data-testid="forgot-email-role">
                <option value="scout">Scout</option><option value="operator">Operator</option><option value="owner">Owner</option>
              </select></label>
            <label className="block"><div className="sb-label">Contact email (where we can reply) *</div>
              <input type="email" required className="sb-input" value={f.email} onChange={(e) => upd("email", e.target.value)} data-testid="forgot-email-contact" /></label>
            <label className="block"><div className="sb-label">Optional note</div>
              <textarea className="sb-input" rows={2} value={f.note} onChange={(e) => upd("note", e.target.value)} data-testid="forgot-email-note" /></label>
            <button type="submit" disabled={busy} className="sb-btn-primary w-full" data-testid="forgot-email-submit">
              {busy ? <Loader2 size={14} className="animate-spin" /> : "Send request"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
